/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateSettingsUnitCommand } from '../../models/update-settings-unit-command';
import { UpdateSettingsUnitCommandResult } from '../../models/update-settings-unit-command-result';

export interface ApiSettingsUnitsUpdateSettingsUnitPatch$Plain$Params {
      body?: UpdateSettingsUnitCommand
}

export function apiSettingsUnitsUpdateSettingsUnitPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiSettingsUnitsUpdateSettingsUnitPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateSettingsUnitCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiSettingsUnitsUpdateSettingsUnitPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateSettingsUnitCommandResult>;
    })
  );
}

apiSettingsUnitsUpdateSettingsUnitPatch$Plain.PATH = '/api/SettingsUnits/UpdateSettingsUnit';
